export default __webpack_public_path__ + "static/media/eight.3137213e.svg";